import { useEffect } from 'react';

/**
 * usePageBgSync - Synchronizes page background with active section
 * 
 * Observes sections with data-page-bg attribute and updates CSS variable
 * when a section becomes active (>50% visible).
 * 
 * @param {boolean} enabled - Whether sync is enabled (default: true)
 */
export function usePageBgSync(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const sections = document.querySelectorAll('section[data-page-bg]');
    if (sections.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const bg = entry.target.dataset.pageBg;
            if (bg && !prefersReducedMotion) {
              document.documentElement.style.setProperty('--page-bg', bg);
            }
          }
        });
      },
      {
        threshold: [0.5, 0.75],
        rootMargin: '0px'
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      observer.disconnect();
    };
  }, [enabled]);
}

export default usePageBgSync;

